import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";
import farmerImage from "src/pods/conundrums/assets/dojosaurusFarmer.png";
import dojosaurusIntro from "src/pods/conundrums/assets/dojosaurusIntro.png";
import mojoImage from "src/pods/conundrums/assets/dojosaurusMojo.png";
import rangerImage from "src/pods/conundrums/assets/dojosaurusRanger.png";

export const Title = "Dojosaurus Rex";
export const Description = "Mojo and his friends have discovered a massive dinosaur on someone else's land!";
export const QuestionText = "Who does it belong to?";

export const Option1String = "Mojo & friends";
export const Twist1String = "Will donate the skeleton to a local museum";
export const Option1Icon = mojoImage;

export const Option2String = "The farmer";
export const Twist2String = "Will use the money to support his family";
export const Option2Icon = farmerImage;

export const Option3String = "The park";
export const Twist3String = "Will sell the skeleton to make entrance to the park free for everyone";
export const Option3Icon = rangerImage;

const activities: Slide[] = [
  IntroSlide(Title, Description, QuestionText, dojosaurusIntro),
  ExpectationsSlide(),
  DescriptionSlide(
    "Mojo and his friends discover a massive Dinosaur skeleton. But half of it is in Yosemite National Park, " +
      "and the other half is on Farmer Spike's land. Who should the dinosaur belong to?",
    dojosaurusIntro,
  ),
  ...getOptionSlides(),
  PairShareSlide(
    "Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?",
  ),
  ShareToStorySlide(
    "Congrats on completing this Conundrum!",
    "Now that was an interesting question indeed.",
    "https://static.classdojo.com/img/dojosaurusShare.png",
    "Great discussion!",
  ),
];
function getOptionSlides(): Slide[] {
  const slides: Slide[] = [];
  const base = 2;

  for (let i = 0; i < Math.pow(2, 3); i++) {
    slides.push(
      OptionsSlide(
        "Who does the dinosaur belong to? Why?",
        [
          {
            option: Option1String,
            icon: Option1Icon,
            twist: { twist: Twist1String, showTwist: Math.floor(i / Math.pow(base, 0)) % base !== 0 },
          },
          {
            option: Option2String,
            icon: Option2Icon,
            twist: { twist: Twist2String, showTwist: Math.floor(i / Math.pow(base, 1)) % base !== 0 },
          },
          {
            option: Option3String,
            icon: Option3Icon,
            twist: { twist: Twist3String, showTwist: Math.floor(i / Math.pow(base, 2)) % base !== 0 },
          },
        ],
        undefined,
        "The skeleton belongs to _____ because...",
      ),
    );
  }
  return slides;
}

export default activities;
